import classnames from 'classnames/bind'
import React from 'react'

import Curve, { CurveProps } from '~/components/Curve'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface CurveComponentProps extends CurveProps {
  className?: string
}

function CurveComponent({ className, ...rest }: CurveComponentProps) {
  return (
    <div className={cx(css.CurveComponent, className)}>
      <div className={css.container}>
        <Curve className={css.curve} {...rest} />
      </div>
    </div>
  )
}

CurveComponent.defaultProps = {}

export default CurveComponent
